import type { Loan } from "./data/types";
import { useNow } from "./NowProvider";
import { OverdueAlert } from "./OverdueAlert";

type Props = {
  loans: Loan[];
};

/** One banner per overdue loan, worst first. Reads the page's shared clock, so a
 *  loan lapsing while the page sits open surfaces on the next tick. */
export function OverdueAlerts(props: Props) {
  const { loans } = props;

  const now = useNow();

  const overdue = loans.filter((loan) => loan.nextDeadline < now).sort((a, b) => a.nextDeadline - b.nextDeadline);

  if (!overdue.length) return null;

  // Tighter than the page's 36px section gap so the banners read as one group.
  // No frame draws a stack — it shows a single banner.
  return (
    <div className="flex flex-col gap-3">
      {overdue.map((loan) => (
        <OverdueAlert key={loan.loanTermsHash} loan={loan} />
      ))}
    </div>
  );
}
